
const SendReconcileMessage = (sendMessage, doc) => {
    console.log('send reconcile')
    sendMessage({
        operation: 'reconcile document',
    })

}

export default function ReconciliationSection(props) {
    let sendMessage = props.sendMessage;
    let doc = props.doc;
    return (
        <div>
            <h3>Document Reconciliation</h3>
            <p>
                In the course of building and upgrading the app, we've changed some things that may have altered how the document's data is used. Reconciliation forces the app to automatically update everything that can be done without user input. Warning characters (⚠️) indicate elements that the system couldn't figure out by itself. You will need to manually update or re-apply these elements yourself.
            </p>
            <br />
            <p>
                <strong>Note:</strong> This may take a moment to process on the server, during which the app will not change. Please be patient.
            </p>
            <br />
            <button
                onClick={() => SendReconcileMessage(sendMessage, doc)}
            >
                Reconcile Document Data
            </button>
        </div>
    )
}
